<template>
    <main>
        <div class="container-fluid">
            <div class="row">
                <div class="col-xxl-12 col-xl-12 col-lg-12 col-md-12 col-sm-12 col-12">
                    <div class="mainButton">
                        <breadcrumbs></breadcrumbs>
                    </div>
                    <div class="page-toolbar">
                        <div class="page-title">
                            <span class="title">Notifications</span>
                            <span class="star"> <i class="fa-solid fa-star"></i></span>
                        </div>
                        <div class="page-create-button">
                            <!--<router-link to="/modules/notifications/edit" class="btn-create">Create</router-link>!-->
                        </div>
                        <div class="page-filter">
                            <input type="search" value="" placeholder="Searching..." class="form-control"
                                v-on:click="openAction">
                            <CustomSearch v-bind:class="{ active: isActive }" @searchEvent="childMethod"
                                @openAction="openAction"></CustomSearch>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <GenericList v-if="generic" ref="loadGeneric"></GenericList>
        <CustomList v-else ref="loadCustom"></CustomList>
    </main>
</template>

<script>
    import { ref } from "vue";
    import breadcrumbs from "@/views/modules/Notifications/MenuList.vue";
    import lang from "@/views/modules/Notifications/language/en";
    import GenericList from "@/components/layout/shared/generic/ListView.vue";
    import CustomList from "@/views/modules/Notifications/ListView.vue";
    import CustomSearch from "@/views/modules/Notifications/SearchView.vue";

    export default {
        name: "new-categorys",
        components: {
            breadcrumbs,
            GenericList,
            CustomList,
            CustomSearch,
        },
        data() {
            return {
                generic: false,
                isActive: false,
                metaList: [
                    {
                        label: lang.LBL_CREATED_BY,
                        link: true,
                        moduleName: 'Notifications',
                        routePath: 'notifications',
                        linkOtherModule: false

                    },
                    {
                        label: lang.LBL_DESCRIPTION,
                        link: false,
                        linkOtherModule: false
                    },
                    {
                        label: lang.LBL_PARENT_TYPE,
                        link: false,
                        linkOtherModule: false
                    },
                    {
                        label: lang.LBL_CREATE_DATE,
                        link: false,
                        linkOtherModule: false
                    },
                ],
                columns: ['created_by', 'description', 'parent_type', 'date_entered'],
            }
        },
        mounted() {
            this.childMethod();
            this.$emit('MetaView', 'Awesome')
        },
        methods: {
            childMethod(search = '') {
                if (this.generic == true) {
                    this.$refs.loadGeneric.loadGenericView(this.metaList, this.columns, search);
                } else {
                    if (search != '') {
                        this.$refs.loadCustom.getNotifications(search);
                    }
                }
            },
            openAction() {
                this.isActive = !this.isActive;
            },
        }
    }
</script>